import { ApiResponse } from './../../models/response-api';
import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EsnJobOfferService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* get list candidat */

  getListjoboffer(data: {
    esn_id: number;
    per_page?: number;
    page?: number;
  })  {
    let page = 1
    if(data?.page){
      page = data?.page + 1
    }
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/JobOffer/getByEsn?esn_id=${data.esn_id}&per_page=${data?.per_page}&page=${page}`);
  }

   getListjobofferByESN(data: {
    esn_id: number;
    per_page?: number;
    page?: number;
  })  {
    let page = 1
    if(data?.page){
      page = data?.page + 1
    }
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/candidate/JobOffer/getByEsn?esn_id=${data.esn_id}&per_page=${data?.per_page}&page=${page}`);
  }

  // create job offer
  createjoboffer(body: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/JobOffer/create',
      body
    );
  }

  // search joboffer//////
  searchjoboffer(data: any): Observable<ApiResponse<any>> {
    if (data?.page){ 
      data.page = data?.page +1
    }
    return this._http
      .post<ApiResponse<any>>(this._base + `/api/JobOffer/search`, data)
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  searchJobsOfEsn(data: any) {
    if(data?.page){
      data.page = data.page + 1;
    }
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/candidate/JobOffer/SearchInListJobByEsn?per_page=${data?.per_page}&page=${data?.page}`,
      data
    );
  }

  freeSearchjoboffer(data: any): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(this._base + `/api/JobOffer/freeSearch`,data)
  }
  /*activer desactiver job offer */
  activerjoboffer(jobOffer_id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/JobOffer/ActivateDesactivate?jobOffer_id=${jobOffer_id}`
    );
  }

  updateJobOffer(id: number, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/JobOffer/update/${id}`,
      data
    );
  }

  /*get job offre  by id */
  getjobofferById(id: number): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/JobOffer/getById/${id}`
    );
  }

  ///////////////////////////
  /*get skills job offre */
  getskillsjoboffre(job_offer_id: number): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/SkillsJob/getByJobOffer?job_offer_id=${job_offer_id}`
    );
  }

  getSkillsJobs() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/SubCategory/getListSubCateg`
    );
  }

  /////////postuler
  postuleroffre(data: any) {
    console.log(
      this._base + `/api/CompanyApply/applyConsultantForJobOffre`,
      data
    );
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/CompanyApply/applyConsultantForJobOffre`,
      data
    );
  }
  getListsuggestionjoboffer(data: {
    esn_id: number;
    job_offer_id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/JobRequest/getSuggestionByESNforJobOfferBesoinEsn?job_offer_id=${data.job_offer_id}&esn_id=${data.esn_id}&per_page=${data?.per_page}&page=${data?.page}${sort}`
    );
  }
  searchconsultantsuggestionofferemploi(
    data: any
  ): Observable<ApiResponse<any>> {
    console.log('data', data);
    let tabs = this.findDoubleQuotes(data.search);

    if (tabs.length <= 2) data.search = '"' + data.search + '"';
    console.log(
      'data of searchCandidat',
      'count = ' + tabs.length,
      data.search
    );
    return this._http
      .post<ApiResponse<any>>(
        this._base +
          `/api/JobRequest/searchInSuggestionByESNforJobOfferBesoinEsn`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  freeSearchconsultantsuggestionofferemploi(
    data: any
  ): Observable<ApiResponse<any>> {
    console.log('data', data);
    let tabs = this.findDoubleQuotes(data.search);

    if (tabs.length <= 2) data.search = '"' + data.search + '"';
    console.log(
      'data of searchCandidat',
      'count = ' + tabs.length,
      data.search
    );
    return this._http
      .post<ApiResponse<any>>(
        this._base +
          `/api/JobRequest/freeSearchInSuggestionByESNforJobOfferBesoinEsn`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }

  findDoubleQuotes(str: string): number[] {
    const indices: number[] = [];
    for (let i = 0; i < str.length; i++) {
      if (str[i] === '"') {
        indices.push(i);
      }
    }
    return indices;
  }
  getListsuggestion(data: {
    job_offer_id: number;
    per_page?: number;
    page?: number;
  }) {
    let page = 1 
    if(data?.page){
      page=data?.page + 1
    }
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/JobRequest/getSuggestionsConsultantsForNosOffres?job_offer_id=${data.job_offer_id}&per_page=${data?.per_page}&page=${page}`
    );
  }
  /* get elment of header table call odder list */
getHeaderElements(id:number){
  return this._http.get<ApiResponse<any>>(this._base+`/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=7&interface=7&id=${id}`);
}
getHeaderElementsentrepriseclienfinal(id:number){
  return this._http.get<ApiResponse<any>>(this._base+`/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=9&interface=9&id=${id}`);

}
  /*suggestion* job offre */
  searchconsultantsuggestionjoboffre(data: any): Observable<ApiResponse<any>> {

    return this._http
      .post<ApiResponse<any>>(
        this._base +
          `/api/JobRequest/searchInSuggestionsConsultantsForNosOffres?job_offer_id=${data.job_offer_id}`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  freeSearchconsultantsuggestionjoboffre(data: any): Observable<ApiResponse<any>> {
    console.log('data', data);
    let tabs = this.findDoubleQuotes(data.search);

    if (tabs.length <= 2) data.search = '"' + data.search + '"';
    console.log(
      'data of searchCandidat',
      'count = ' + tabs.length,
      data.search
    );
    return this._http
      .post<ApiResponse<any>>(
        this._base +
          `/api/JobRequest/freeSearchInSuggestionsConsultantsForNosOffres?esn_id=${data.esn_id}&job_offer_id=${data.job_offer_id}`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
  /* add  bareme for job  */
  addBareme(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/JobOfferScore/saveOrUpdateScore`,
      data
    );
  }

  compareCandidates(
    data: any,
  ): Observable<ApiResponse<any>> {
      return this._http.post<ApiResponse<any>>(
        this._base + `/api/ScoreESN/compare`,
        data
      );
  }
  getBarem(job_offer_id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/JobOfferScore/jobOfferScoreDetails?offer_id=${job_offer_id}`
    );
  }
  /* add  bareme for job client  */
  addBaremeClient(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/ScoreJob/createScoreJobRequest`,
      data
    );
  }
  getBaremClient(job_request_id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/ScoreJob/getScoreJobRequestDetails?job_request_id=${job_request_id}`
    );
  }
  listPagejobofferActorIntervenant() {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForEmployee?interface=7&company_id=2&id=16`
    );
  }
  /* change Sub Page State */
  changeSubPageStateIntervenant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/UserPageActeur/addRemoveSubPageByEmployee`,
      data
    );
  }
  listPageesnjobofferActorIntervenant() {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForEmployee?interface=7&company_id=2&id=13`
    );
  }
  /* change Sub Page State */
  changeSubPageStateesnjobofferIntervenant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/UserPageActeur/addRemoveSubPageByEmployee`,
      data
    );
  }
  changeDelectedElementHeader(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/addRemoveSubPageToUser?role_id=7&interface=7`,
      data
    );
  }

  getcandidatureById(user_id : any,job_offer_id:any): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/CandidateJobOffer/getDetailsCandidaturesByjobOfferESN?user_id=${user_id}&job_offer_id=${job_offer_id}`
    );
  }

  getDetailScore(jobOfferId: number, candidateId: string) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/JobOfferScore/getCandidateScoreDetails?job_offer_id=${jobOfferId}&candidate_id=${candidateId}`
    );
  }
}
